import { uri } from '../../api-endpoint';
import { IImageInfoFromAPISuccessResponse } from '../../type-conversion/image-info/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchModelImageListAPI = (token: string) => (modelId: number) =>
  fetchListTemplateFn(
    token,
    uri.modelImageList(modelId),
    IImageInfoFromAPISuccessResponse
  );
